/**
 * alertRuleConfiguration模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const alertRuleConfiguration = {
  //删除默认告警规则
  alertRuleConfigurationDelete(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/delete`,param);
  },
  //启用禁用
  changeStatus(params) {
    return $http.post(`${global.API_URL}/sme/alertRuleConfiguration/changeStatus`,params);
  }
}

export default alertRuleConfiguration;



// WEBPACK FOOTER //
// ./src/api/alertRuleConfiguration.js